import styled from 'styled-components';
import snu from 'images/snu.svg';
import quorumbio from 'images/quorumbio/logo1.jpg';
import i1 from 'images/quorumbio/1.png';
import i2 from 'images/quorumbio/2.jpg';
import i3 from 'images/quorumbio/3.png';
import i4 from 'images/quorumbio/4.jpg';
import i5 from 'images/quorumbio/5.jpg';
import i6 from 'images/quorumbio/6.png';
import i7 from 'images/quorumbio/7.jpg';
import i8 from 'images/quorumbio/8.jpg';

const TopBar = styled.div`
  position: fixed;
  width: 100%;
  height: 50px;
  // background: #f1f2f1;
  // background: pink;
  background: LavenderBlush;
  display: flex;
  justify-content: center;
  align-items: center;
  // margin-top: 10px;  
`;

const Dummy = styled.div`
  height: 50px;
  // background: red;
`;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  
  // background: red;

  &:hover {
    background: #eaeaea;
    background: lightgray;
    cursor: pointer;
  }
`;

const Icon = styled.div`
  // width: 40px;
  // height: 40px;
  width: 80px;
  margin-left: 10px;
  // cursor: pointer;
`;

const Title = styled.label`
  margin-left: 10px;
  font-size: 20px;
  cursor: pointer;
  font-weight: 500;
`;

const Image = styled.div`
  width: 100%;
`;

const QuorumBio = () => {
  const handleGoHomepage = () => {
    window.open('https://www.quorumbio.com');
  };

  return (
    <div className="QuorumBio">
      <TopBar>
        <Container onClick={handleGoHomepage}>
          <Icon>
            <img src={quorumbio} alt="quorumbio" width="100%" />
          </Icon>
          <Title>쿼럼바이오(주)</Title>
        </Container>
      </TopBar>
      <Dummy />
      <Image><img src={i1} alt="image1" width="100%" /></Image>
      <Image><img src={i2} alt="image2" width="100%" /></Image>
      <Image><img src={i3} alt="image3" width="100%" /></Image>
      <Image><img src={i4} alt="image4" width="100%" /></Image>
      <Image><img src={i5} alt="image5" width="100%" /></Image>
      <Image><img src={i6} alt="image6" width="100%" /></Image>
      <Image><img src={i7} alt="image7" width="100%" /></Image>
      <Image><img src={i8} alt="image8" width="100%" /></Image>
    </div>
  );
};

export default QuorumBio;